/**
 *
 */
export type SearchPagination = {
  page: number;
  totalItems?: number;
  rowsPerPage: number | null;
  sortBy: string;
  descending: boolean;
};
/**
 * Defines the object used to send filter params to API
 */
export type SearchFilter = {
  key: string;
  value: string | number;
  label: string;
};
/**
 * Array of SearchFilters
 */
export type SearchFilters = SearchFilter[];

/**
 * Singleton class for keeping search params state
 */
class SearchService {
  private _pagination: SearchPagination;
  private _filters: SearchFilters;

  constructor() {
    this._pagination = {
      page: 1,
      rowsPerPage: 10,
      sortBy: "id",
      descending: true,
      totalItems: 0,
    };
    this._filters = [];
  }

  get pagination() {
    return this._pagination;
  }

  set pagination(pag: SearchPagination) {
    this._pagination = pag;
  }

  get filters() {
    return this._filters;
  }

  set filters(filt: SearchFilters) {
    this._filters = filt;
  }

  clear = () => {
    this._pagination = {
      page: 1,
      rowsPerPage: 10,
      sortBy: "id",
      descending: true,
    };
    this._filters = [];
  };
}

let searchService = new SearchService();

export default searchService;
